import React from 'react'
import NavLite from '../../components/NavLite'
import Footer from '../../components/Footer'

function AccessibilityAudits() {
  <main>
  <title>Website Accessibility Audits | Inclusive Design for All | Her Growth Co.</title>
<meta
name="description"
content="Ensure your website is accessible and compliant. Our audits help women entrepreneurs create inclusive, user-friendly experiences."
/>
<meta
name="keywords"
content="website accessibility for women-owned brands, ADA-compliant design, inclusive web audits, improve site accessibility, accessible design for female founders, usability for all users, WCAG standards for websites, digital inclusion strategies"
/>
</main>
  return (
    <div> 
    
    <NavLite/>
    <div className="text-center items-center justify-center text-9xl mt-10">
    Coming Soon
    </div>
    <Footer/>
    </div>
  )
}

export default AccessibilityAudits